// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__2d6FG","loading":"loader_loading__2jaf4"};